/* global debounce */
import { LottieAnimator } from '~bergBlockPath/lottie-animator/js/core-event-handler';
$( $ => {
  const wrapperDiv = $( '.bs-section--features-with-four-blurbs' );
  if ( wrapperDiv.length === 0 ) return;
  const isMobile = () => {
    return window.matchMedia( '(max-width: 767.98px)' ).matches;
  };
  if ( wrapperDiv.length === 0 || !isMobile() ) { return; }
  const blurbs = wrapperDiv.find( '.bs-div--features-blurb-wrapper-accordion' );
  const descriptions = wrapperDiv.find( '.bs-blurb__description' );
  const learnMores = wrapperDiv.find( '.bs-blurb__read-more' );
  const images = wrapperDiv.find( '.bs-lottie-animator, .lottie-mask' );
  const duration = 200;
  blurbs.prepend( '<span class="bs-accordion-toggle"></span>' );
  const accordionToggle = wrapperDiv.find( '.bs-accordion-toggle' );

  const allLotties = [];
  const initLotties = lotties => {
    lotties.each ( ( i, lottie ) => {
      const lottieAnim = new LottieAnimator ( lottie );
      lottieAnim.init();
      allLotties.push ( lottieAnim );
    } );
  };
  const expandBlurb = ( blurb, id=false ) => {
    const selectedDescription = blurb.find( '.bs-blurb__description' );
    const selectedLearnMore = blurb.find( '.bs-blurb__read-more' );
    const selectedImage = blurb.find( '.bs-lottie-animator, .lottie-mask' );

    descriptions.not( selectedDescription ).slideUp( duration );
    learnMores.not( selectedLearnMore ).slideUp( duration );
    images.not( selectedImage ).slideUp( duration );

    blurbs.not( blurb ).removeClass( 'expanded' );

    selectedDescription.slideDown( duration );
    selectedLearnMore.slideDown( duration );
    selectedImage.slideDown( duration );

    blurb.addClass( 'expanded' );

    if ( id && allLotties[id] ) {
      const currLottie = allLotties[id].lottieAnimation;
      currLottie.play();
      setInterval( () => { currLottie.goToAndStop( 0, true );currLottie.play(); }, 5000 );
    }
  };

  const collapseBlurb = blurb => {
    const selectedDescription = blurb.find( '.bs-blurb__description' );
    const selectedLearnMore = blurb.find( '.bs-blurb__read-more' );
    const selectedImage = blurb.find( '.bs-lottie-animator, .lottie-mask' );

    selectedDescription.slideUp( duration );
    selectedLearnMore.slideUp( duration );
    selectedImage.slideUp( duration );

    blurb.removeClass( 'expanded' );
  };

  const init = () => {
    const lotties = wrapperDiv.find( '.bs-lottie-animator' );
    if( lotties.length !== 0 ) {
      initLotties( lotties );
    }

    expandBlurb( blurbs.eq( 0 ) ); 
			
    // check first accordion is in view
    const observer = new IntersectionObserver( entries => {
      if ( entries[0].isIntersecting && allLotties[0] ) {
        const currLottie = allLotties[0].lottieAnimation;
        currLottie.play();
        setInterval( () => { currLottie.goToAndStop( 0, true );currLottie.play(); }, 5000 );
        observer.disconnect();
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 1, 
    } );
    observer.observe( blurbs[0] );
  };

  accordionToggle.on( 'click', e => {
    const blurb = $( e.target ).closest( '.bs-div--features-blurb-wrapper-accordion' );
    if ( blurb.hasClass( 'expanded' ) ) {
      collapseBlurb( blurb );
      return;
    }
    expandBlurb( blurb, blurb.index() );
  } );

  init();
  $( window ).on( 'orientationchange', debounce( init, 100 ) );
} );
